// One-backend plan step 3, 4b-ii-b (design §13a): a World helper's notice is a line the platform writes into the conversation
// that started it (event kind `helper-notice`, backend lib/cleoHelperNotices.js). It is never Cleo's words and never the
// person's message; every screen says it in these same words (the Desk's pane and Pocket).

export type HelperNoticeKind = "waiting" | "died";

export interface HelperNotice {
  readonly noticeKind: HelperNoticeKind;
  readonly title: string;
  readonly what: string;
  readonly helperSessionId: string;
}

const text = (value: unknown): string => (typeof value === "string" ? value : "");

/** The notice a `helper-notice` event's body holds, or null for a kind or shape these words do not say. */
export function helperNoticeOf(body: Readonly<Record<string, unknown>> | null | undefined): HelperNotice | null {
  const noticeKind = body?.["noticeKind"];
  const helperSessionId = text(body?.["helperSessionId"]);
  if ((noticeKind !== "waiting" && noticeKind !== "died") || !helperSessionId) return null;
  return { noticeKind, title: text(body?.["title"]), what: text(body?.["what"]), helperSessionId };
}

/** The line, in the person's words. */
export function helperNoticeWords(row: { readonly noticeKind: HelperNoticeKind; readonly title: string; readonly what: string }): string {
  return row.noticeKind === "waiting"
    ? `A helper needs you: “${row.title}” is waiting for your approval (${row.what}).`
    : `A helper stopped: “${row.title}”, ${row.what}.`;
}
